import { useQuery } from '@tanstack/react-query';
import {
  fetchUnitCostCoverage,
  fetchUnitCostDetail,
  fetchUnitCosts,
  type UnitCostWindowParams,
} from '@/api/unitCosts';

/**
 * The ledger behind these endpoints is written once a day, so caching for
 * five minutes costs nothing in freshness and keeps the table snappy while
 * a user sorts and filters.
 */
const FIVE_MIN = 5 * 60 * 1000;

export function useUnitCosts(params: UnitCostWindowParams) {
  return useQuery({
    queryKey: ['unit-costs', params],
    queryFn: () => fetchUnitCosts(params),
    staleTime: FIVE_MIN,
  });
}

export function useUnitCostCoverage(params: UnitCostWindowParams) {
  return useQuery({
    queryKey: ['unit-cost-coverage', params],
    queryFn: () => fetchUnitCostCoverage(params),
    staleTime: FIVE_MIN,
  });
}

export function useUnitCostDetail(
  serviceSlug: string | undefined,
  params: UnitCostWindowParams,
) {
  return useQuery({
    queryKey: ['unit-cost-detail', serviceSlug, params],
    queryFn: () => fetchUnitCostDetail(serviceSlug!, params),
    enabled: !!serviceSlug,
    staleTime: FIVE_MIN,
  });
}
